import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GoogleObj } from '../models/GoogleObj';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class GoogletranslateService {


  url = "https://translation.googleapis.com/language/translate/v2?key=AIzaSyA9Z5i11e4-3sOHa8HhgPSg6uRgwEAudes";
  //key = "AIzaSyC2NR6Kd-UKT7VekzioEULFtuylp1XEKKA";
  constructor(private http: HttpClient) { }
  translate(obj: GoogleObj): Observable<any>  {
    console.log(obj)
  return this.http.post(this.url , obj);
  }}
